import {
  ApolloError,
  gql,
  useMutation,
} from "@apollo/client";
import { 
    MarkSharedOfferMutationMutation,
    MarkSharedOfferMutationMutationVariables 
} from "../../../schemaTypes";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";
import { normalizeErrors } from "../../../utils/normalizeErrors";

export const markSharedOfferMutation = gql`
  mutation MarkSharedOfferMutation(
    $id: String!
  ) {
    markSharedOffer(
      id: $id
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  onMessage?: (message: string) => void;
  children: (
    data: {
      submit: (
        values: MarkSharedOfferMutationMutationVariables
      ) => Promise<{
        errors: NormalizedErrorMap | null;
        message?: string;
      }>;
      loading: boolean;
      error?: ApolloError;
    }
  ) => React.ReactElement | null;
}

export const MarkSharedOfferController: React.FC<Props> = ({
  children,
  onMessage,
}) => {
  const [markSharedOfferMutationFn, { loading, error }] =
    useMutation<
      MarkSharedOfferMutationMutation,
      MarkSharedOfferMutationMutationVariables
    >(markSharedOfferMutation);

  const submit = async (
    values: MarkSharedOfferMutationMutationVariables
  ) => {
    const response = await markSharedOfferMutationFn({
      variables: values,
    });

    const data = response.data?.markSharedOffer;

    const errors = data?.errors
      ? normalizeErrors(data.errors)
      : null;

    if (data?.message && onMessage) {
      onMessage(data.message);
    }

    return {
      errors,
      message: data?.message ?? undefined,
    };
  };

  return children({ submit, loading, error });
};